'use client'

import React from 'react'
import { Analytics } from '@vercel/analytics/react'
import { Lexend, Poppins } from 'next/font/google'
import { ThemeProvider } from 'next-themes'
import '@src/styles/globals.css'
import clsx from 'clsx'
import DynamicBackground from '@src/components/elements/DynamicBackground'

const poppins = Poppins({
  weight: '400',
  display: 'swap',
  subsets: ['latin'],
  variable: '--font-poppins',
})

const lexend = Lexend({
  weight: '400',
  display: 'swap',
  subsets: ['latin'],
  variable: '--font-lexend',
})

export default function RootLayout({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <html lang="en" className={clsx(poppins.variable, lexend.variable)}>
      <head>
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width"
        />
        <title>Nick Vu's Portfolio</title>
        <meta name="description" content="Nick Vu's Portfolio" />
        <link rel="icon" href="/favicon.ico" />
      </head>
      <body>
        <style jsx global>{`
          html {
            font-family: ${[
              poppins.style?.fontFamily,
              'Customized Verdana',
            ].join(', ')};
          }
        `}</style>
        <Analytics />
        <ThemeProvider attribute="data-theme" defaultTheme="light">
          <DynamicBackground />
          {children}
        </ThemeProvider>
      </body>
    </html>
  )
}
